import type { FunctionComponent, HTMLAttributes, ReactElement } from 'react';

import styles from './ModalContainer.module.css';

export interface ModalContainerProps extends HTMLAttributes<HTMLDivElement> {}

export const ModalContainer: FunctionComponent<ModalContainerProps> = ({ children, ...rest }): ReactElement => {
  return (
    <div className={styles.modalContainer} {...rest}>
      {children}
    </div>
  );
};
